// extracted by mini-css-extract-plugin
export default {"container":"TypeOptions_container__tr9lB","selected":"TypeOptions_selected__8WHVB"};